export default __webpack_public_path__ + "static/media/logout_icon.9cf05e10.svg";